import InvestmentAccreditation from './InvestmentAccreditation'

export default InvestmentAccreditation
